import CryptoJS from 'crypto-js';
import config from '../appconfig/config.json';
import mbCards from '../data/mayBankCardBIN.json';


const encrypt = (text) => {
    //   return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    return CryptoJS.AES.encrypt(text, config.SECRET_KEY).toString();
};

const decrypt = (ciphertext) => {
    //   return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
    let originalText = '';
    let bytes = CryptoJS.AES.decrypt(ciphertext, config.SECRET_KEY);

    originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
};

const isMayBankCardBINList = (value) => {
    let isMBCard = false;
    for (let i in mbCards) {
        if (value === mbCards[i]) {
            isMBCard = true;
            return isMBCard
        }
    }

    return isMBCard
}

const toHomeScreen = () => {
    let url = '';
    let params = localStorage.getItem('p');
    let queryStr = '';

    if (params) {
        if (params === config.SRC_CODE_HNW) {
            queryStr = '?p=U2FsdGVkX18njfeygnz2PJtTtbOsoJt29npOcJgM0kM'
        } else if (params === config.SRC_CODE_CCFT03) {
            queryStr = '?p=U2FsdGVkX191x3XcxVyb8riWQnTBPFuRJiTnzJ8lPrw'
        } else if (params === config.SRC_CODE_CCFT04) {
            queryStr = '?p=U2FsdGVkX19spgrgxtU55243WOzLbGULj44RaIl8bt0'
        } else if (params === config.SRC_CODE_CCFT05) {
            queryStr = '?p=U2FsdGVkX19SmWK3JZEXKKbjFwVaxznXadU9IVKiIu4'
        } else if (params === config.SRC_CODE_CCFT06) {
            queryStr = '?p=U2FsdGVkX19sSvYm2kWiDBUET64zAsU95ppkcHpDKFc'
        } else if (params === config.SRC_CODE_CCFT) {
            queryStr = '?p=U2FsdGVkX186eY9LS3f6elp6OcUvVL2o1UliENaneSo'
        } else if (params === config.SRC_CODE_OUTSIDERS) {
            queryStr = '?p=U2FsdGVkX18R2Kokj3yUy3XUW1PSktWTmpwJt0CZPpg'
        }
    }
    // U2FsdGVkX1+YNrcpzk8kfOFOJO03pS09+hAeuAWbOIU=
    // 810204 U2FsdGVkX19spgrgxtU55243WOzLbGULj44RaIl8bt0=
    // 810205 U2FsdGVkX19SmWK3JZEXKKbjFwVaxznXadU9IVKiIu4=
    // 810206 U2FsdGVkX19sSvYm2kWiDBUET64zAsU95ppkcHpDKFc==


    if (config.SERVER_STATUS === 'SIT') {
        url = config.URL_ToHomeScreen_SIT;
        document.location.href = url + queryStr;
    }
    else if (config.SERVER_STATUS === 'UAT') {
        url = config.URL_ToHomeScreen;
        document.location.href = url + queryStr;
    }
    else if (config.SERVER_STATUS === 'PROD') {
        url = config.URL_ToHomeScreen_PROD;
        document.location.href = url + queryStr;
    }
}

const displayAmtNote = () => {
    let params = localStorage.getItem('p');
    let str = '';
    if (params) { // Apr 2024
        if (params === config.SRC_CODE_HNW || params === config.SRC_CODE_OUTSIDERS) {
            str = 'S$2,000';
        } else if (params === config.SRC_CODE_CCFT || params === config.SRC_CODE_CCFT03 || params === config.SRC_CODE_CCFT04 || params === config.SRC_CODE_CCFT05 || params === config.SRC_CODE_CCFT06) {
            str = 'S$1,000';
        }
    }

    return str;
}

const getAmtValidValue = () => {
    let params = localStorage.getItem('p');
    let amt = 2000;
    if (params) {
        if (params === config.SRC_CODE_HNW || params === config.SRC_CODE_OUTSIDERS) {
            amt = 2000;
        } else if (params === config.SRC_CODE_CCFT || params === config.SRC_CODE_CCFT03 || params === config.SRC_CODE_CCFT04 || params === config.SRC_CODE_CCFT05 || params === config.SRC_CODE_CCFT06) {
            amt = 1000
        }
    }
    return amt;
}


export default {
    encrypt,
    decrypt,
    isMayBankCardBINList,
    toHomeScreen,
    displayAmtNote,
    getAmtValidValue
}